import { render, staticRenderFns } from "./BodyDeContasAPagar.vue?vue&type=template&id=568a3a97&scoped=true"
import script from "./BodyDeContasAPagar.vue?vue&type=script&setup=true&lang=js"
export * from "./BodyDeContasAPagar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BodyDeContasAPagar.vue?vue&type=style&index=0&id=568a3a97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568a3a97",
  null
  
)

export default component.exports